module.exports = __webpack_public_path__ + "img/writing-notepad.258c3d1b.svg";